@if (!showSuccess && !isDemoBooked) {
  <panel [panelInput]="panelConfig" (close)="fnClosePanel()">
    <ng-container panel-body>
      <div class="border-content__area info-acent-grident-bg-3 gap-12">
          <div class="ai-surface icon-box-rounded"><img [src]="ICONS.GEMINI_AI" alt=""></div>
          <h6 class="title-18 new-ai-text">{{ 'book_demo_hero_title' | translate }}</h6>
          <p class="paragraph-12">{{ 'book_demo_hero_desc' | translate }}</p>
          <hr class="hr-border-muted">
          <ul class="ds-info-text --icon-shield --info">
              <li>{{ 'book_demo_no_pitch' | translate }}</li>
          </ul>
      </div>
      <div class="white-info-container flex-row justify-content-between align-items-center">
          <div class="our-team__online">
              <div class="active-team__list">
                  <div class="active-team __item-one">
                      <span>JK</span>
                  </div>
                  <div class="active-team __item-two">
                      <span>SN</span>
                  </div>
                  <div class="active-team __item-three">
                      <span>PM</span>
                  </div>
              </div>
              <div>
                  <h6 class="title-14">{{ 'book_demo_team_online' | translate }}</h6>
                  <p class="paragraph-10 text-placeholder">{{ 'book_demo_avg_time' | translate }}</p>
              </div>
          </div>
          <div class="grid-status --success">
            <img [src]="ICONS.BULLET" />
            <span>{{ 'book_demo_live' | translate }}</span>
        </div>
      </div>
    </ng-container>

    <ng-container panel-footer>
      <ds-button [buttonInput]="cancelButtonConfig" (btnClick)="fnClosePanel()"></ds-button>
      <ds-button [buttonInput]="submitButtonConfig" (btnClick)="fnOpenCalendlyModal()"></ds-button>
    </ng-container>
  </panel>
}

    <ds-modal [modalInput]="successModalConfig" (visibleChange)="onSuccessModalVisibleChange($event)">
    <ng-container modal-body>
      <div class="d-flex flex-column gap-12 align-items-center justify-content-center">
        <div class="icon-box --x-large-img --primary-subtle rounded-circle"><img [src]="ICONS.CHECK_CIRCLE" alt=""></div>
        <h6 class="title-18">{{ 'book_demo_received_title' | translate }}</h6>
        <hr class="hr-border-focus w-25pc">
        <p class="paragraph-14 text-center" [innerHTML]="'book_demo_received_message' | translate"></p>
        <ds-button [buttonInput]="continueExploringButtonConfig" (btnClick)="onSuccessModalVisibleChange(false)"></ds-button>
        <p class="paragraph-14 text-placeholder">{{ 'book_demo_received_subtitle' | translate }}</p>
      </div>
    </ng-container>
  </ds-modal>

  <ds-modal [modalInput]="alreadySentModalConfig" (visibleChange)="onAlreadySentModalVisibleChange($event)">
    <ng-container modal-body>
      <div class="d-flex flex-column gap-12 align-items-center justify-content-center">
        <div class="icon-box --x-large-img --primary-subtle rounded-circle"><img [src]="ICONS.CHECK_CIRCLE" alt=""></div>
        <h6 class="title-18">{{ 'book_demo_already_sent_title' | translate }}</h6>
        <hr class="hr-border-focus w-25pc">
        <p class="paragraph-14 text-center" [innerHTML]="'book_demo_received_message' | translate"></p>
        <ds-button [buttonInput]="continueExploringButtonConfig" (btnClick)="onAlreadySentModalVisibleChange(false)"></ds-button>
        <p class="paragraph-14 text-placeholder">{{ 'book_demo_received_subtitle' | translate }}</p>
      </div>
    </ng-container>
  </ds-modal>

  <ds-modal [modalInput]="calendlyModalConfig" (visibleChange)="onCalendlyModalVisibleChange($event)">
    <ng-container modal-body>
      <div class="heightCalc-10">
            <iframe [src]="safeCalendlyUrl"
              width="100%"
              height="100%"
              frameborder="0"
              style="border: 0"
              allowfullscreen>
            </iframe>
      </div>
    </ng-container>
    <ng-container modal-footer>
      <ds-button [buttonInput]="calendlyConfirmButtonConfig" (btnClick)="fnConfirmDemoRequest()"></ds-button>
    </ng-container>
  </ds-modal>
